export default  {
    ExpenseBudget: 1,
    RevenueBusiness: 2,
    ExpenseBusiness: 3,
    RevenueFees: 4,
    ExpenseFees: 5,
};
